import { useEffect, useRef } from 'react';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { useModalControl } from '@frontend/design-system';
import { OnboardingFlowInitiatorModal } from '../../../components/onboarding-flow-components/onboarding-flow-initiator-modal';
import { useOnboardingFlowInfo } from '../../../hooks/onboarding-flow-hooks/use-onboarding-flow-info';
import { useShouldShowOnboardingFlow } from '../../../hooks/onboarding-flow-hooks/use-should-show-onboarding-flow';
import { useGetCalendarV3QueriesData } from '../../../hooks/scheduler-v3/use-get-calendar-v3-queries-data';

export const ScheduleOnboardingFlowModal = () => {
  const { navigate, isOpen: isSettingsOpen } = useSettingsNavigate();
  const { shouldShowOnboardingFlow } = useShouldShowOnboardingFlow();
  const {
    onboardingFlowInfo,
    setShowOnNextLogin,
    setOnboardingFlowInfo,
    shouldShowOnboardingFlowModal,
    isBookAppointmentVisible,
  } = useOnboardingFlowInfo();
  const { calendarLocationIds } = useGetCalendarV3QueriesData();
  const isSetupClickedRef = useRef(false);
  const modalControls = useModalControl({
    onClose: () => {
      if (!isSetupClickedRef.current) {
        setShowOnNextLogin();
      }
    },
  });

  const shouldShowModal = shouldShowOnboardingFlow && shouldShowOnboardingFlowModal;

  useEffect(() => {
    if (
      !isSettingsOpen &&
      !isBookAppointmentVisible &&
      onboardingFlowInfo.status === 'in_progress' &&
      isSetupClickedRef.current
    ) {
      // for setting panel close case, show onboarding flow on next login if user is still in in-progress onboarding flow
      setShowOnNextLogin();
    }
  }, [isSettingsOpen, isBookAppointmentVisible, onboardingFlowInfo.status, isSetupClickedRef.current]);

  useEffect(() => {
    if (shouldShowModal) {
      modalControls.openModal();
    }
  }, [shouldShowModal]);

  const handleSetupClick = () => {
    isSetupClickedRef.current = true;
    navigate({ to: '/schedule', context: { shouldShowOnboardingFlow: true, calendarLocationIds } });
    setOnboardingFlowInfo({ status: 'in_progress' });
    modalControls.closeModal();
  };

  if (!shouldShowOnboardingFlow) {
    return null;
  }

  return <OnboardingFlowInitiatorModal {...modalControls.modalProps} onSetUpClick={handleSetupClick} />;
};
